import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { GroupForm } from "./GroupForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface IGroupCreateProps {}

export const GroupCreate = (props: IGroupCreateProps) => {
  const notify = useNotification(props, "createSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.Group,
    (x) => x.create
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Create
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        title="resources.admin-groups.title.create">
        <GroupForm />
      </Create>
    </FieldPermissionsContext.Provider>
  );
};
